export default {
  id: (state: {[key:string]: string}) => {
    return state.id
  },

  name: (state: {[key:string]: string}) => {
    return state.name
  }
}
